export const VERSIONS = [
    {
        label: 'latest (v6)',
        value: 'latest'
    },
    {
        label: 'v5',
        value: 'v5'
    },
];